var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLandscape = function SvgLandscape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1.964 1.464C.5 2.93.5 5.286.5 10s0 7.071 1.464 8.535C3.43 20 5.786 20 10.5 20s7.071 0 8.535-1.465C20.5 17.072 20.5 14.715 20.5 10s0-7.071-1.465-8.536C17.572 0 15.215 0 10.5 0S3.429 0 1.964 1.464M14.5 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m-9.68 3.104a1.55 1.55 0 0 1 2.184.073l2.647 2.81c.8.849 2.109.963 3.043.266a1.57 1.57 0 0 1 2.02.123l2.268 2.166a.75.75 0 0 0 1.036-1.084L15.75 13.29a3.07 3.07 0 0 0-3.953-.24.795.795 0 0 1-1.054-.093l-2.647-2.81a3.05 3.05 0 0 0-4.296-.143l-.81.752a.75.75 0 1 0 1.02 1.1z",
    clipRule: "evenodd"
  })));
};
export default SvgLandscape;